import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=48e8e5af&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=48e8e5af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e8e5af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48e8e5af')) {
      api.createRecord('48e8e5af', component.options)
    } else {
      api.reload('48e8e5af', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=48e8e5af&scoped=true&", function () {
      api.rerender('48e8e5af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Si36eypDqa1c/JS/comp/PopupBox.vue"
export default component.exports